import { createClient } from "@connectrpc/connect";
import {
  BaseGrpcCatalogService,
  GrpcCatalogoFetchResult,
} from "../../../../base/services/BaseGrpcCatalogService";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import {
  CatalogosAplicacionesService,
  LoteNoProductivoItem,
} from "../../../../generated/grpc/catalogos_aplicaciones_pb";

/** Catálogo de coberturas de un lote NO productivo (cuerpo de agua, bosque,
 *  construcción…) — el equivalente de `CultivoGrpcCatalogService` para las
 *  áreas que no producen. Lo consume el paso 5 del wizard de registro de
 *  finca (`LoteAssignBarRender`): al marcar un lote como "no productiva" se
 *  elige de acá en vez del catálogo de cultivos.
 *
 *  Mismo mecanismo que el resto de los catálogos gRPC: delta por watermark y
 *  cache local en IndexedDB (store `lotesNoProductivos`). */
export class LoteNoProductivoGrpcCatalogService extends BaseGrpcCatalogService<LoteNoProductivoItem> {
  protected readonly storeName = "lotesNoProductivos" as const;
  protected readonly sortFieldName = "nombre";

  protected async fetchAsync(
    ultimaSincronizacion: bigint,
  ): Promise<GrpcCatalogoFetchResult<LoteNoProductivoItem>> {
    const client = createClient(
      CatalogosAplicacionesService,
      grpcTransportProvider.get(),
    );

    try {
      const response = await client.listLotesNoProductivos({
        ultimaSincronizacion,
      });
      return {
        items: response.items,
        timestampSincronizacion: response.timestampSincronizacion,
      };
    } catch (error) {
      throw mapConnectError(error);
    }
  }
}

/** Singleton del servicio gRPC del catálogo de coberturas no productivas. */
export const loteNoProductivoGrpcCatalogService =
  new LoteNoProductivoGrpcCatalogService();
